<script lang="jsx">
export default {
  functional: true,
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  render (h, context) {
    // return createElement('span', [this.node]);
    return context.props.node;
  }
};
</script>
